import { Box } from '@bechtel/gds';
import styled, { css } from 'styled-components';
export const EllipseStyled = styled(Box).attrs({ mr: { sm: '400' }, alignSelf: { sm: 'center' } })`
  ${({ theme }) =>
    css`
      width: ${theme.spacings[100]};
      height: ${theme.spacings[100]};
      background-color: ${theme.colors.grey[700]};
    `}
`;
